import React from "react";
import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./components/HomeLinks";
import Countries from "./components/countries";
import Country from "./components/country";
import NoMatch from "./components/NoMatch";
import Index from "./components/Index";
import AllCountries from "./components/AllCountries";

const App = ({ login }) => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!login) return;
		setLoading(true);
		fetch(`${login}`)
			.then((Response) => Response.json())
			.then(setData)
			.then(() => setLoading(false))
			.catch(setError);
	}, [login]);
	if (loading) return <h1 className="text-pink-400">Loading.....</h1>;
	if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>;
	if (!data) return null;

	return (
		<Routes>
			<Route path="/" element={<Home />}>
				<Route path="/countries" element={<Countries data={data} />}>
					<Route index element={<Index />} />
					<Route path="allcountries" element={<AllCountries data={data} />}>
						<Route path=":countryId" element={<Country data={data} />} />
					</Route>
					<Route path=":countryId" element={<Country data={data} />} />
				</Route>
				<Route path="*" element={<NoMatch />} />
			</Route>
		</Routes>
	);
};

export default App;
